import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./orcamentos-e-pacotes-listar/orcamentos-e-pacotes-listar.module').then(m => m.OrcamentosEPacotesListarModule) },
    { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./orcamentos-e-pacotes-inserir/orcamentos-e-pacotes-inserir.module').then(m => m.OrcamentosEPacotesInserirModule) },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./orcamentos-e-pacotes-editar/orcamentos-e-pacotes-editar.module').then(m => m.OrcamentosEPacotesEditarModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./orcamentos-e-pacotes-detalhar/orcamentos-e-pacotes-detalhar.module').then(m => m.OrcamentosEPacotesDetalharModule) }
  ])],
  exports: [RouterModule]
})
export class OrcamentosEPacotesRoutingModule { }
